module.exports = __webpack_public_path__ + "static/models/start_line.ff987d8.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/start_line.json
// module id = 532
// module chunks = 1